/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const optionDataRequestSchema = z.object({
	id: z.string().nullable().optional(),
	label: z.string(),
	position: z.number(),
	isDisqualifying: z.boolean().nullable().optional().default(false),
	scoreValue: z.number().nullable().optional(),
	consentType: z.string().nullable().optional(),
})

export type OptionDataRequestSchema = z.infer<typeof optionDataRequestSchema>
